export default __webpack_public_path__ + "static/media/CreateMeta.c130e0b8.gif";